import { Grid, Pagination } from "@mui/material";
import SelectBox from "../../../../components/SelectBox";

export const Paging = ({ totalCount, page, itemsPerPage, changePage, changeItemsPerPage }) => {

  const handleChangeItemPerPage = (e) => {
    changeItemsPerPage(e.target.value)
  }

  const handleClickPageButton = (e, newPage) => {
    changePage(newPage)
  }

  return (
    <Grid container display="flex" justifyContent="space-between" mt={5}>
      <Grid item xs={2}>
        <SelectBox
          data={[10, 25, 50].map((x) => {
            return {
              key: x,
              value: x,
            };
          })}
          onChange={handleChangeItemPerPage}
          value={itemsPerPage}
          sx={{ width: 100 }}
          label={"表示件数　"}
          nullable={false}
        />
      </Grid>
      <Grid item xs={8} display="flex" justifyContent="center">
        <Pagination
          count={Math.ceil(totalCount / itemsPerPage)}
          page={page}
          onChange={handleClickPageButton}
          variant="outlined"
          shape="rounded"
        />
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
};